module.exports = __webpack_public_path__ + "img/1725844843045-screenshot-1725844825286.png.dd203428.webp";